import { Navigate, Route, Routes } from "react-router-dom"
import { Fragment } from "react/jsx-runtime"
import NotFound from "ui/components/NotFound"
import Spacer from "ui/components/Spacer"
import Execute from "./Execute.js"
import ExecutionPage from "./ExecutionPage.js"
import PublicNav from "./PublicNav.js"
import View from "./View.js"

export default function LookupRouter() {
    return (
        <Fragment>
            <PublicNav />
            <Spacer />
            <Routes>
                <Route path="" element={<Navigate to="view" replace />} />
                <Route path="view" element={<View />} />
                <Route path="execute" element={<Execute />} />
                <Route path="execution/:executionId" element={<ExecutionPage />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Fragment>
    )
}
